import { render, staticRenderFns } from "./CreditsListItem.vue?vue&type=template&id=b21bc042&scoped=true&"
import script from "./CreditsListItem.vue?vue&type=script&lang=js&"
export * from "./CreditsListItem.vue?vue&type=script&lang=js&"
import style0 from "./CreditsListItem.vue?vue&type=style&index=0&id=b21bc042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21bc042",
  null
  
)

export default component.exports